import { CloseButtonSt } from './CloseButton.css';
import { usePlainTranslate } from 'app/shared/components/Translation/hooks/usePlainTranslate/usePlainTranslate';
import { Close } from '@heycar-uikit/icons';

export const CloseButton = props => {
  const plainTranslate = usePlainTranslate();
  return (
    <CloseButtonSt
      ariaLabel={plainTranslate({
        id: 'shared.components.notification.close',
        defaultMessage: 'Close',
      })}
      {...props}
    >
      <Close />
    </CloseButtonSt>
  );
};
